// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FIfww","webViewContainer":"styles_webViewContainer__L7DSX"};